import { createRoute, redirect } from '@tanstack/react-router'
import { managementLayoutRoute } from '@/ui/pages/management'
import { useAuthStore } from '@/application/stores/auth.store'
import { SiteIdentitySection } from './components/SiteIdentitySection'
import { SocialSettingsSection } from './components/SocialSettingsSection'
import { BreakingNewsSection } from './components/BreakingNewsSection'

export const settingsRoute = createRoute({
  getParentRoute: () => managementLayoutRoute,
  path: 'settings',
  beforeLoad: () => {
    const { user } = useAuthStore.getState()
    if (user?.role !== 'streamer' && user?.role !== 'admin') {
      throw redirect({ to: '/manage/dashboard' })
    }
  },
  component: SettingsPage,
})

export function SettingsPage() {
  return (
    <div className="space-y-6">
      <BreakingNewsSection />
      <SiteIdentitySection />
      <SocialSettingsSection />
    </div>
  )
}
